import { ChainId } from '@padiswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xc8160deb19559d93eadb82798ededce696ebcaf5', // TODO
  [ChainId.TESTNET]: '0xc8160deb19559d93eadb82798ededce696ebcaf5', // TODO
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
